
import { useEffect } from 'react';
import ShopNavbar from './components/ShopNavbar';
import ShopHero from './components/ShopHero';
import ShopClasses from './components/ShopClasses';
import ShopKits from './components/ShopKits';
import ShopManuals from './components/ShopManuals';
import ShopPackages from './components/ShopPackages';
import ShopFooter from './components/ShopFooter';

export default function ShopPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <ShopNavbar />
      <ShopHero />
      <ShopClasses />
      <ShopKits />
      <ShopManuals />
      <ShopPackages />
      <ShopFooter />
    </div>
  );
}
